import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RelatedProductsPanel = ({
  relatedProducts = [],
  onProductSelect = () => {},
  className = ''
}) => {
  if (relatedProducts?.length === 0) {
    return (
      <div className={`bg-card border border-border rounded-lg p-6 ${className}`}>
        <div className="text-center text-muted-foreground">
          <Icon name="Package" size={32} className="mx-auto mb-2 opacity-50" />
          <p className="text-sm">No related products found</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-card border border-border rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-foreground">
          Related Products
        </h3>
        <span className="text-xs text-muted-foreground">
          {relatedProducts?.length} found
        </span>
      </div>
      <div className="space-y-3 max-h-64 overflow-y-auto">
        {relatedProducts?.map((product, index) => (
          <div
            key={index}
            onClick={() => onProductSelect(product)}
            className="flex items-start space-x-3 p-3 rounded-lg border border-border hover:bg-muted cursor-pointer transition-colors duration-150"
          >
            {/* Product Image */}
            <div className="flex-shrink-0 w-12 h-12 bg-muted rounded overflow-hidden">
              {product?.image ? (
                <Image
                  src={product?.image}
                  alt={product?.imageAlt}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <Icon name="Package" size={16} className="text-muted-foreground" />
                </div>
              )}
            </div>

            {/* Product Details */}
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground truncate">
                {product?.name}
              </h4>
              <p className="text-xs text-muted-foreground truncate">
                {product?.brand}
              </p>
              
              {/* Price and Similarity */}
              <div className="flex items-center justify-between mt-1">
                <span className="text-sm font-semibold text-foreground">
                  ${product?.price?.toFixed(2)}
                </span>
                {product?.similarity && (
                  <span className={`text-xs px-1.5 py-0.5 rounded ${
                    product?.similarity >= 0.8 
                      ? 'bg-success bg-opacity-10 text-success' :'bg-warning bg-opacity-10 text-warning'
                  }`}>
                    {Math.round(product?.similarity * 100)}%
                  </span>
                )}
              </div>

              {/* Matching Attributes */}
              {product?.matchingAttributes && product?.matchingAttributes?.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {product?.matchingAttributes?.slice(0, 3)?.map((attr, attrIndex) => (
                    <span
                      key={attrIndex}
                      className="text-xs px-1.5 py-0.5 bg-primary bg-opacity-10 text-primary rounded"
                    >
                      {attr}
                    </span>
                  ))}
                  {product?.matchingAttributes?.length > 3 && (
                    <span className="text-xs text-muted-foreground">
                      +{product?.matchingAttributes?.length - 3}
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* Action Icon */}
            <div className="flex-shrink-0">
              <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            </div>
          </div>
        ))}
      </div>
      {/* View All Button */}
      {relatedProducts?.length > 5 && (
        <div className="pt-3 border-t border-border mt-3">
          <button className="w-full text-sm text-primary hover:text-primary-foreground hover:bg-primary rounded-md py-2 transition-colors duration-150">
            View All Related Products
          </button>
        </div>
      )}
    </div>
  );
};

export default RelatedProductsPanel;